module.exports = __webpack_public_path__ + "img/news-bg2.e4ecb843.jpg";